import * as React from 'react'

import * as Style from './style.css'

export type IProps = React.PropsWithChildren

export const StepProgress = ({ children }: IProps): JSX.Element => (
  <ul className={Style.StepProgress}>{children}</ul>
)
